// hook
import { useEffect, useState } from "react";

// cookie
// @ts-ignore
import Cookies from "js-cookie";

// splitter
import { splitNumber } from "../../../features/splitNumber/splitNumber";

// layouts
import { Link } from "react-router-dom";

const ErrorPayment = () => {
    const [user, setUser] = useState<object | any>();
    const [status, setStatus] = useState<boolean>(false);

    useEffect(() => {
        document.getElementById("site-main")?.classList.remove("main-content");
        document.getElementById("site-main")?.classList.add("bg-payment-new");
        document.getElementById("site-main")?.classList.add("bg-payment-new-error");
        document.getElementById("site-main")?.classList.add("bg-white");

        let user: any = Cookies.get("userData");
        user = JSON.parse(user);

        if (user?.isWallet === false) {
            setStatus(true);
        } else {
            setStatus(false);
        }

        setUser(user);
    }, []);

    const now = new Date();

    const formatter = new Intl.DateTimeFormat("fa-IR", {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
    });

    const formatted = formatter.format(now);

    const isIranTarakonesh =
        Cookies.get("irt") === "true" ||
        user?.returnUrl === "https://" ||
        user?.returnUrl === null;

    const returnLink = isIranTarakonesh
        ? "https://irantarakonesh.ir/"
        : user?.returnUrl;

    return (
        <>
            <article className="payment h-100 overflow-x-hidden">
                <div className="row justify-content-center h-100">

                    <header className="container text-center">
                        <div
                            className="top-bar"
                            style={{ paddingBottom: "15px" }}
                        >
                            <div className="d-flex justify-content-center">
                                <img
                                    alt="logo"
                                    src={require(
                                        "./../../../assets/media/logo/Logo_Iran Tarakonesh_Vr_33_Sefid 1.webp"
                                    )}
                                    className="img-fluid"
                                />
                            </div>

                            <p className="text-white text-center mb-5 fw-bold">
                                سامانه ملی امن, سریع و آسان تراکنش ایران
                            </p>
                        </div>
                    </header>

                    <div className="col-12">
                        <div id="text-field">

                            <section
                                style={{ marginTop: "-100px" }}
                                className="profile container"
                            >
                                <div className="profile-items d-flex justify-content-center text-center">

                                    {status ? (
                                        <>
                                            {user?.image ? (
                                                <>
                                                    <img
                                                        alt="profile"
                                                        className="profile-img-valid"
                                                        src={user.image}
                                                    />
                                                </>
                                            ) : (
                                                <>
                                                    {user?.urlName === 'Shufti' ?
                                                        (
                                                            <img src={require('./../../../assets/media/logo/sh.png')} alt="" style={{ width: '100px', height: '80px' }} className='mt-3' />
                                                        )
                                                        : (
                                                            <>
                                                                <img
                                                                    className="profile-img-valid"
                                                                    src={require('./../../../assets/media/images/payment/Profile_Vr_01 1.png')} />
                                                            </>
                                                        )}
                                                </>
                                            )}
                                        </>
                                    ) : (
                                        <>
                                            <h5 className="text-red text-center mt-1 fw-bold">
                                                شارژ حساب کاربری ایران تراکنش
                                            </h5>
                                        </>
                                    )}

                                </div>

                                {Cookies.get("irt") === "true" ?
                                    <>
                                        {status ?
                                            (
                                                <>
                                                    <p className={'fw-bold text-center mt-3 mb-1'}>
                                                        <span className={'ms-1'}>
                                                            {user?.firstName}
                                                        </span>
                                                        {user?.lastName}
                                                    </p>
                                                </>
                                            ) : null}
                                    </>
                                    :
                                    <>
                                        {!status ?
                                            (
                                                <></>
                                            ) :
                                            <>
                                                <p className={'fw-bold text-center mt-3 mb-1'}>
                                                    <span>
                                                        {user?.irtName}
                                                    </span>
                                                </p>
                                            </>
                                        }
                                    </>
                                }

                                {user?.urlName !== 'Shufti' ?
                                    (
                                        <>
                                            <p className={'text-muted text-center mb-2'}>
                                                {status ? user?.merchantCode : `${user?.mobile}`}
                                            </p>
                                        </>
                                    )
                                    : null}
                            </section>

                            <section className="bg-white text-center">

                                <span
                                    className="badge bg-danger mt-2 py-2 fw-bold"
                                    style={{ fontSize: "18px" }}
                                >
                                    {!status
                                        ? "عملیات افزایش موجودی ناموفق"
                                        : "پرداخت در وجه پذیرنده انجام نشد"}
                                </span>

                                <p
                                    style={{ fontSize: "10px" }}
                                    className="mb-0 mt-2 px-3"
                                >
                                    در صورت کسر وجه ؛ مبلغ طی نهایت ۷۲ ساعت
                                    به حساب بانکی شما عودت می گردد.
                                </p>

                            </section>

                            <div className="px-4">

                                <ul className="list-group font-small list-group-flush mt-4 px-0">

                                    <li className="list-group-item px-0">
                                        <div className="d-flex justify-content-between">

                                            <p className="mb-0">
                                                موجودی فعلی ایران تراکنشی شما
                                            </p>

                                            <p className="price fw-bold card-text mb-0">
                                                <span className="price-amount ms-1">
                                                    {splitNumber(
                                                        user?.currentBalance
                                                    )}
                                                </span>
                                                ریال
                                            </p>

                                        </div>

                                        <hr />
                                    </li>

                                    <li className="list-group-item border px-0">
                                        <div className="d-flex justify-content-between">

                                            <span className="text-muted">
                                                زمان
                                            </span>

                                            <span className="fw-bold">
                                                {formatted}
                                            </span>

                                        </div>

                                        <hr />
                                    </li>

                                    <li className="list-group-item border px-0">
                                        <div className="d-flex justify-content-between">

                                            <span className="text-muted">
                                                وضعیت پرداخت
                                            </span>

                                            <span className="fw-bold">
                                                ناموفق
                                            </span>

                                        </div>
                                    </li>

                                </ul>

                            </div>

                            <div className="d-flex justify-content-center mb-2 mt-4">
                                <Link
                                    id="share"
                                    to={returnLink}
                                    className="dark-green font-medium mb-2 py-2 me-2 rounded-pill align-middle font-medium btn-site btn fw-bold"
                                >
                                    {isIranTarakonesh
                                        ? "ورود به ایران تراکنش"
                                        : `بازگشت به ${user?.irtName}`}
                                </Link>
                            </div>

                        </div>
                    </div>

                </div>
            </article>
        </>
    );
};

export default ErrorPayment;